var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStackedBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1662_33",
    "data-name": "Component 1662 \\u2013 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44458",
    "data-name": "Group 44458",
    transform: "translate(-613.005 -1037.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49560",
    "data-name": "Path 49560",
    d: "M629.718,1041.005a.686.686,0,0,1,.348.674c-.012,1.866-.009,3.732-.011,5.6l-.347.055a7.733,7.733,0,0,0-6.171,9.664,7.455,7.455,0,0,0,3.383,4.527,7.779,7.779,0,0,0,8.858-.5q2.028,2.021,4.053,4.043c.268.27.215.571-.12.836a13.821,13.821,0,0,1-5.493,2.661,14.011,14.011,0,0,1-16.573-9.432,14.291,14.291,0,0,1-.583-2.9c-.006-.058.02-.131-.057-.167v-2.291c.089-.042.053-.127.06-.192a14.056,14.056,0,0,1,10.927-12.323,7.649,7.649,0,0,0,1.18-.253Z",
    fill: "#1689fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49561",
    "data-name": "Path 49561",
    d: "M631.963,1047.281q0-2.875-.01-5.751a.664.664,0,0,1,.329-.525h.491c.431.088.864.167,1.293.263a13.979,13.979,0,0,1,10.653,10.81c.088.416.148.839.208,1.261a.523.523,0,0,1-.51.635.5.5,0,0,1-.054,0l-5.7-.008a7.4,7.4,0,0,0-.638-2.231,7.724,7.724,0,0,0-6.063-4.456Z",
    fill: "#fc003a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49562",
    "data-name": "Path 49562",
    d: "M635.778,1061.027a7.779,7.779,0,0,1-8.858.5,7.455,7.455,0,0,1-3.383-4.527,7.714,7.714,0,0,1,6.171-9.664l.347-.055a9.177,9.177,0,0,1,.013,1.546c-.015.269-.214.4-.463.469a5.692,5.692,0,0,0-4.218,4.17,5.811,5.811,0,0,0,8.58,6.477c.4-.227.542-.208.861.114S635.462,1060.7,635.778,1061.027Z",
    fill: "#137fd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49563",
    "data-name": "Path 49563",
    d: "M638.663,1055.859c1.908,0,3.815-.009,5.723-.006a.514.514,0,0,1,.548.622,13.866,13.866,0,0,1-2.927,7.128.527.527,0,0,1-.914.052q-1.918-1.917-3.835-3.835c-.044-.045-.083-.095-.124-.143a9.531,9.531,0,0,0,.951-1.636A6.612,6.612,0,0,0,638.663,1055.859Z",
    fill: "#fd9923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49564",
    "data-name": "Path 49564",
    d: "M631.963,1047.281a7.724,7.724,0,0,1,6.063,4.456,7.4,7.4,0,0,1,.638,2.231c-.5.005-1,.024-1.5.01-.3-.008-.447-.213-.524-.5a5.848,5.848,0,0,0-4.188-4.18c-.4-.1-.5-.235-.5-.653C631.955,1048.19,631.96,1047.735,631.963,1047.281Z",
    fill: "#e40128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49565",
    "data-name": "Path 49565",
    d: "M638.663,1055.859a6.612,6.612,0,0,1-.578,2.182,9.531,9.531,0,0,1-.951,1.636c-.4-.34-.756-.728-1.122-1.1a.446.446,0,0,1-.051-.577,6.327,6.327,0,0,0,.724-1.746.489.489,0,0,1,.511-.4C637.685,1055.846,638.174,1055.855,638.663,1055.859Z",
    fill: "#e5841a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14071",
    "data-name": "Rectangle 14071",
    width: 36,
    height: 36,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStackedBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_stacked_bar_chart.71acba9140c4fc4120280bba79d3a093.svg";